import type { BoxProps, StyleSystemProps } from '@withjoy/joykit';
import { styled, Flex } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

// The translucent card the menu floats on. This is PopoverV2's `Content` part, which is the
// element PopoverV1 called the "transition element".
const popoverContentProps: BoxProps = {
  background: 'rgba(255, 255, 255, 0.9)',
  borderRadius: 4,
  // PopoverV2's content ships a drop shadow of its own; the elevation here belongs to the inner
  // body below, so clear it rather than stacking the two.
  boxShadow: 'none',
};

// The blurred pane the menu items sit on. This is PopoverV2's `Body` part, which is the element
// PopoverV1 called the "content".
const popoverBodyProps: BoxProps = {
  borderRadius: 'inherit',
  boxShadow: '0px 30px 60px rgba(68, 50, 93, 0.05), 0px 18px 36px rgba(0, 0, 0, 0.06)',
  backgroundColor: 'unset',
  backdropFilter: 'saturate(180%) blur(8px)',
};

export const StyledPillContainer = styled(Flex)<{ $isWidgetOpen: boolean }>`
  svg {
    transition: ${animationTransition('transform')};
    ${({ $isWidgetOpen }) => {
      return {
        transform: `rotate(${$isWidgetOpen ? '-180deg' : '0deg'})`,
      };
    }}
  }
`;
const pillContainerStyles: StyleSystemProps = {
  cursor: 'pointer',
  border: '1px solid',
  borderColor: 'gray3',
  alignItems: 'center',
  borderRadius: 24,
  backgroundColor: 'white',
  padding: 1,
};

export const styles = {
  pillContainer: pillContainerStyles,
  popoverContentProps,
  popoverBodyProps,
};
